// ============================================
// 📋 FORMULÁRIO MULTI-IDS - form-multi-ids.js
// Suporta múltiplos formulários com IDs diferentes
// Form ID: 880226
// ============================================

(function initMultiForm() {
  console.log("🔵 [FORM MULTI] Inicializando sistema multi-formulários");
  
  const COOKIE_NAME = "utm_campaign";
  const COOKIE_DAYS = 30;
  const FORM_ID = "880226";
  
  // ==========================================
  // 🎯 ADICIONE TODOS OS IDs DE CONTAINERS AQUI
  // ==========================================
  const CONTAINER_IDS = [
    "#AeDFJWnVFYUdRMC9yc__forms_inline_8jaDwi",  // Form pagina de contato
    "#AaDF4VEVNNEpxVzVSa__forms_inline_3HCi64",  // Pagina institucional
    "#AUWZYRFpnWW1GaUxCO__forms_inline_7LkrBc"   // Pagina trabalhe conosco 

  ];

  // Controle de instâncias processadas
  const processedForms = new WeakSet();

  // ==========================================
  // 🔧 FUNÇÕES AUXILIARES - UTM
  // ==========================================
  function setCookie(name, value, days) {
    if (!value) return;
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${expires.toUTCString()}; path=/`;
    console.log("🔵 [FORM MULTI] Cookie UTM salvo:", value);
  }

  function getCookie(name) {
    const cookies = document.cookie.split("; ");
    const cookie = cookies.find(c => c.startsWith(name + "="));
    return cookie ? decodeURIComponent(cookie.split("=")[1]) : "";
  }

  function getUTMValue() {
    const params = new URLSearchParams(window.location.search);
    const utmFromUrl = params.get("utm_campaign");
    
    let utmValue = "";
    if (utmFromUrl) {
      utmValue = utmFromUrl;
      setCookie(COOKIE_NAME, utmFromUrl, COOKIE_DAYS);
    } else {
      utmValue = getCookie(COOKIE_NAME);
    }
    
    return utmValue;
  }

  // ==========================================
  // 🎨 APLICAR ESTILOS NO FORMULÁRIO
  // ==========================================
  function applyFormStyles(targetForm, appEmbed, utmField, containerId) {
    const isMobile = window.innerWidth <= 768;
    let formStarted = false;
    const utmValue = getUTMValue();

    console.log("✅ [FORM MULTI] Aplicando estilos no formulário");
    console.log("   📦 Container ID:", containerId);
    console.log("   📍 Página:", window.location.pathname);

    // ==========================================
    // 🏷️ UTM - CAMPO OCULTO
    // ==========================================
    if (utmValue && utmField) {
      utmField.value = utmValue;
      utmField.dispatchEvent(new Event("input", { bubbles: true }));
      utmField.dispatchEvent(new Event("change", { bubbles: true }));
      console.log("✅ [FORM MULTI] UTM aplicado:", utmValue);
    }

    // Oculta o campo UTM completamente
    if (utmField) {
      const utmWrapper = utmField.closest('[data-testid="form-field-wrapper"]');
      if (utmWrapper) {
        utmWrapper.style.cssText = "display: none !important; visibility: hidden !important; height: 0 !important; margin: 0 !important; padding: 0 !important;";
      }
      
      utmField.style.cssText = "display: none !important; visibility: hidden !important;";
      
      const utmLabel = appEmbed.shadowRoot.querySelector('label[for*="utm"]');
      if (utmLabel) {
        utmLabel.style.cssText = "display: none !important; visibility: hidden !important;";
      }
    }

    // ==========================================
    // 🎨 WRAPPER - ESTILO ROXO/AZUL
    // ==========================================
    const shadow = appEmbed.shadowRoot;

      if (shadow) {
        const sheet = new CSSStyleSheet();

        sheet.replaceSync(`
          .section-form {
            padding: ${isMobile ? '0px' : '35px 0 0'};
            max-width: 550px !important;
            margin: 0 auto;
          }


          h2._formBannerHeading_z5ku3_9{
          font-size: 0 !important;
        }
        h2._formBannerHeading_z5ku3_9::before{
          content: "Recebemos sua mensagem!";
          font-size: 22px;
          color: #022D2F;
          margin-bottom: 30px;
        }

        section._formBannerContainer_z5ku3_1 ._textBody_2aowh_10 p{
          font-size: 0;
        }

        section._formBannerContainer_z5ku3_1 ._textBody_2aowh_10 p::before{
          content: "Olá! Obrigado por entrar em contato conosco. Sua mensagem já está com nosso time de atendimento. Analisaremos sua solicitação e, em breve, te daremos um retorno Se o seu assunto for urgente, sinta-se à vontade para nos chamar diretamente no WhatsApp. +55 (11) 99945-4971";
          font-size: 16px;
          color: #022D2F;
          text-align: center;
              line-height: normal;
          }


          @media (max-width: 768px) {
            section._formHeader_cit2d_24 {
              margin: 25px;
              text-align: left;
            }
            section._formHeader_cit2d_24 h2{
              color: #022D2F;
            }
          }
        `);

        shadow.adoptedStyleSheets = [
          ...shadow.adoptedStyleSheets,
          sheet
        ];

        const formWrapper = shadow.querySelector(
          'section[data-sizing="form-wrapper"]'
        );

        if (formWrapper) {
          formWrapper.classList.add('section-form');
        }
      }

      
    // ==========================================
    // 📝 INPUTS - EVENTOS E ESTILOS
    // ==========================================
    const allInputs = targetForm.querySelectorAll('input');
    console.log(`🔵 [FORM MULTI] ${allInputs.length} inputs encontrados`);

    allInputs.forEach(input => {
      // Evento de início de preenchimento
      input.addEventListener('focus', () => {
        if (!formStarted) {
          formStarted = true;
          
          console.log("🎯 [FORM MULTI] ========================================");
          console.log("🎯 [FORM MULTI] USUÁRIO COMEÇOU A PREENCHER!");
          console.log("🎯 [FORM MULTI] Form ID: 880226");
          console.log("🎯 [FORM MULTI] Container:", containerId);
          console.log("🎯 [FORM MULTI] Página:", window.location.pathname);
          console.log("🎯 [FORM MULTI] ========================================");

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'event': 'initiate_form',
            'form_id': FORM_ID,
            'form_type': 'standard',
            'container_id': containerId,
            'page_url': window.location.href,
            'timestamp': new Date().getTime()
          });
        }
      }, { once: true });

      // Estilos dos inputs - ROXO/AZUL
      input.style.cssText += `
        color: #A6A6A6 !important;
        background: transparent;
        font-size: 15px !important;
        border: 1px solid #959595 !important;
        border-radius: 10px !important;
        box-sizing: border-box !important;
        font-family: Montserrat !important;
        transition: 0.3s !important;
      `;

      // Efeito hover nos inputs
      input.addEventListener('focus', () => {
        input.style.borderColor = "#5e35b1 !important";
        input.style.boxShadow = "0 0 0 3px rgba(94, 53, 177, 0.1) !important";
      });

      input.addEventListener('blur', () => {
        input.style.borderColor = "#7e57c2 !important";
        input.style.boxShadow = "none !important";
      });
    });

    // ==========================================
    // 🏷️ LABELS - ESTILOS
    // ==========================================
    const allLabels = targetForm.querySelectorAll('label');
    allLabels.forEach(label => {
      // estilo padrão para todas
      label.style.cssText += `
        font-family: Montserrat !important;
        font-size: 14px !important;
        color: #A6A6A6 !important;
        font-weight: 500 !important;
      `;

      // estilo adicional só para phone_number
        if (label.getAttribute('for') === 'label-phone_number') {
          console.log("passou")
          label.style.setProperty('transform', 'translateY(-10px)', 'important');
        }
    })


   // ==========================================
  // 📝 TEXTAREA MENSAGEM
  // ==========================================

     // evita duplicar o style
if (!shadow.querySelector('#custom-form-style')) {

  const style = document.createElement('style');
  style.id = 'custom-form-style';

  style.textContent = `
    /* Remove fundo do pseudo-elemento do container que tem textarea */
    ._formFieldContainer_1mxsl_5:has(textarea)::before {
      background: transparent  !important;
    }

    form._formFieldset_cit2d_82{
      padding: 0 15px !important;
    }

    /* Estilo do textarea específico */
    textarea[name="custom#mensagem"] {
      background: transparent;
      border: 1px solid rgb(149, 149, 149);
    }
  `;

  shadow.appendChild(style);
}




    // ==========================================
    // 🚀 BOTÃO DE ENVIO
    // ==========================================
    const submitBtn = targetForm.querySelector('button[data-testid="btn-form-submit"]');
    if (submitBtn) {
      submitBtn.style.cssText += `
        width: ${isMobile ? '100%' : '30%'} !important;
        transform: translateY(0px);
        background: #022D2F;
        border-radius: 100px;
        width: 93% !important;
        font-family: Montserrat !important;
        color: rgb(255, 255, 255);
        font-weight: bold;
        font-size: 16px;
        cursor: pointer;
        display: block;
        text-align: center;
        margin: 0px auto;
        padding: 16px;
        transition: 0.3s;
      `;

      // Hover effect
      submitBtn.addEventListener('mouseenter', () => {
        submitBtn.style.transform = "translateY(-2px)";
      });

      submitBtn.addEventListener('mouseleave', () => {
        submitBtn.style.transform = "translateY(0)";
      });

      // Evento de submit
      submitBtn.addEventListener("click", () => {
        const nome = targetForm.querySelector('#first_name')?.value || '';
        const email = targetForm.querySelector('#email')?.value || '';
        const whatsapp = targetForm.querySelector('#phone_number')?.value || '';
        // const local = targetForm.querySelector('#custom\\#local_do_casamento')?.value || '';
        const dia = targetForm.querySelector('input[aria-labelledby="label-DD"]')?.value;
        const mes = targetForm.querySelector('input[aria-labelledby="label-MM"]')?.value;
        const ano = targetForm.querySelector('input[aria-labelledby="label-YYYY"]')?.value;

        // const dataCasamento = (dia && mes && ano) ? `${dia}/${mes}/${ano}` : "Não informado";

        console.log("🚀 [FORM MULTI] ========================================");
        console.log("🚀 [FORM MULTI] FORMULÁRIO ENVIADO!");
        console.log("🚀 [FORM MULTI] Form ID: 880226");
        console.log("🚀 [FORM MULTI] Container:", containerId);
        console.log("🚀 [FORM MULTI] Página:", window.location.pathname);
        console.log("🚀 [FORM MULTI] ========================================");
        console.log("🚀 [FORM MULTI] Dados capturados:");
        console.log("   📝 Nome:", nome);
        console.log("   📧 Email:", email);
        console.log("   📱 WhatsApp:", whatsapp);
        // console.log("   📅 Data Casamento:", dataCasamento);
        // console.log("   📍 Local:", local);
        console.log("   🏷️ UTM:", utmValue);
        console.log("🚀 [FORM MULTI] ========================================");

        // window.dataLayer = window.dataLayer || [];
        // window.dataLayer.push({
        //   'event': 'lead_form_submit',
        //   'form_id': FORM_ID,
        //   'container_id': containerId,
        //   'page_url': window.location.href,
        //   'form_data': {
        //     'nome': nome,
        //     'email': email,
        //     'whatsapp': whatsapp,
        //     'data_casamento': dataCasamento,
        //     'local_casamento': local,
        //     'utm_campaign': utmValue
        //   }
        // });
      });
    }

    // ==========================================
    // 🌍 BOTÃO DE PAÍS (se existir)
    // ==========================================
    const countryBtn = appEmbed.shadowRoot.querySelector('button[class*="selectToggle"]');
    if (countryBtn) {
      countryBtn.style.cssText += `
        background: transparent;
        border: 1px solid #A6A6A6 !important;
        border-radius: 10px !important;
        height: 100% !important;
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        margin-right: 5px !important;
        max-height: 51px !important;
      `;
    }


    // ==========================================
// 🌐 TRADUÇÃO DE ERROS DE VALIDAÇÃO
// ==========================================
function translateFormErrors(shadow) {
  const translations = {
    // Erros de campo obrigatório
    'First name is required': 'Nome é obrigatório',
    'Last name is required': 'Sobrenome é obrigatório',
    'Phone number is required': 'Telefone é obrigatório',
    'Email is required': 'E-mail é obrigatório',
    'Email is invalid': 'E-mail é inválido',
    'Field is required': 'Campo obrigatório',
    'This field is required': 'Este campo é obrigatório',

    // Erros de formato
    'Please enter a valid email': 'Digite um e-mail válido',
    'Please enter a valid email address': 'Digite um e-mail válido',
    'Invalid email address': 'E-mail inválido',
    'Please enter a valid phone number': 'Digite um telefone válido',
    'Invalid phone number': 'Telefone inválido',

    // Outros
    'Please fill in this field': 'Preencha este campo',
    'Value is too short': 'Valor muito curto',
    'Value is too long': 'Valor muito longo',
  };

  function applyTranslations() {
    const errorElements = shadow.querySelectorAll(
      'output[role="alert"], ._formError_1mxsl_21, [class*="formError"]'
    );

    errorElements.forEach(el => {
      const original = el.textContent.trim();
      if (translations[original]) {
        el.textContent = translations[original];
      }
    });
  }

  // Aplica imediatamente
  applyTranslations();

  // Observa mudanças para traduzir erros que aparecem após submit
  const errorObserver = new MutationObserver(() => {
    applyTranslations();
  });

  errorObserver.observe(shadow, {
    childList: true,
    subtree: true,
    characterData: true
  });
}

    if (shadow) {
  translateFormErrors(shadow);
}

// ==========================================
// 🎭 MÁSCARAS DE INPUT
// ==========================================
function applyInputMasks(targetForm) {
  const phoneInput = targetForm.querySelector('#phone_number');
  if (!phoneInput) return;

  // Evita registrar múltiplos listeners no mesmo input
  if (phoneInput.dataset.maskApplied) return;
  phoneInput.dataset.maskApplied = 'true';

  phoneInput.setAttribute('maxlength', '19');
  phoneInput.setAttribute('placeholder', '+55 (XX) XXXXX-XXXX');

  function applyPhoneMask(value) {
    // Extrai apenas dígitos e limita HARD a 13
    let digits = value.replace(/\D/g, '').slice(0, 13);

    if (digits.length === 0) return '';
    if (digits.length <= 2)  return `+${digits}`;
    if (digits.length <= 4)  return `+${digits.slice(0,2)} (${digits.slice(2)}`;
    if (digits.length <= 9)  return `+${digits.slice(0,2)} (${digits.slice(2,4)}) ${digits.slice(4)}`;
    return `+${digits.slice(0,2)} (${digits.slice(2,4)}) ${digits.slice(4,9)}-${digits.slice(9)}`;
  }

  phoneInput.addEventListener('input', (e) => {
  const input = e.target;
  const cursorPos = input.selectionStart;
  const prevValue = input.value;

  // Conta quantos dígitos existiam antes do cursor
  const digitsBeforeCursor = prevValue.slice(0, cursorPos).replace(/\D/g, '').length;

  // Aplica máscara
  const digits = input.value.replace(/\D/g, '').slice(0, 13);
  const masked = applyPhoneMask(digits);
  input.value = masked;

  // Reposiciona o cursor: avança pelos chars da máscara até cobrir os dígitos anteriores
  let newCursor = 0;
  let digitCount = 0;
  for (let i = 0; i < masked.length; i++) {
    if (/\d/.test(masked[i])) digitCount++;
    if (digitCount === digitsBeforeCursor) {
      newCursor = i + 1;
      break;
    }
  }

  // Se não achou (campo vazio ou cursor no início), vai pro final
  if (digitsBeforeCursor === 0) newCursor = masked.length;

  input.setSelectionRange(newCursor, newCursor);
});

  phoneInput.addEventListener('paste', (e) => {
    e.preventDefault();
    const pasted = (e.clipboardData || window.clipboardData).getData('text');
    const digits = pasted.replace(/\D/g, '').slice(0, 13);
    phoneInput.value = applyPhoneMask(digits);
    phoneInput.dispatchEvent(new Event('input', { bubbles: true }));
  });

  phoneInput.addEventListener('blur', () => {
    const digits = phoneInput.value.replace(/\D/g, '');
    if (digits.length > 0 && digits.length < 13) {
      phoneInput.style.borderColor = '#ff4d4d';
      phoneInput.title = 'Digite o número completo: +55 (XX) XXXXX-XXXX';
    } else {
      phoneInput.style.borderColor = '';
      phoneInput.title = '';
    }
  });
}

applyInputMasks(targetForm);

    // Marca como processado usando WeakSet
    processedForms.add(targetForm);
    console.log("✅ [FORM MULTI] Formulário configurado com sucesso!");
  }

  // ==========================================
  // 🔍 PROCESSAR TODOS OS FORMULÁRIOS
  // ==========================================
  const processAllForms = () => {
    let formsFound = 0;
    let formsProcessed = 0;

    CONTAINER_IDS.forEach(containerId => {
      const container = document.querySelector(containerId);

      if (!container) {
        return;
      }

      const appEmbed = container.querySelector('#app-embed');
      
      if (!appEmbed || !appEmbed.shadowRoot) {
        return;
      }

      const targetForm = appEmbed.shadowRoot.querySelector('form');
      const utmField = appEmbed.shadowRoot.querySelector('#custom\\#utm');

      if (!targetForm) {
        return;
      }

      formsFound++;

      // Verifica se já foi processado usando WeakSet
      if (processedForms.has(targetForm)) {
        return;
      }

      // Aplica os estilos
      applyFormStyles(targetForm, appEmbed, utmField, containerId);
      formsProcessed++;
    });

    if (formsProcessed > 0) {
      console.log(`✅ [FORM MULTI] ${formsProcessed} formulário(s) processado(s) nesta execução`);
    }

    return formsProcessed > 0;
  };

  // ==========================================
  // 👀 OBSERVER PERMANENTE - MONITORA DOM
  // ==========================================
  const observer = new MutationObserver(() => {
    processAllForms();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // ==========================================
  // 🔄 LISTENER PARA MUDANÇAS DE PÁGINA
  // ==========================================
  
  // Para SPAs (Single Page Applications)
  let lastUrl = location.href;
  new MutationObserver(() => {
    const url = location.href;
    if (url !== lastUrl) {
      lastUrl = url;
      console.log("🔄 [FORM MULTI] Mudança de página detectada:", url);
      
      setTimeout(() => processAllForms(), 500);
      setTimeout(() => processAllForms(), 1000);
      setTimeout(() => processAllForms(), 2000);
    }
  }).observe(document, { subtree: true, childList: true });

  // Para navegação com History API
  const originalPushState = history.pushState;
  const originalReplaceState = history.replaceState;

  history.pushState = function() {
    originalPushState.apply(this, arguments);
    console.log("🔄 [FORM MULTI] PushState detectado");
    setTimeout(() => processAllForms(), 500);
    setTimeout(() => processAllForms(), 1000);
  };

  history.replaceState = function() {
    originalReplaceState.apply(this, arguments);
    console.log("🔄 [FORM MULTI] ReplaceState detectado");
    setTimeout(() => processAllForms(), 500);
  };

  // Listener para evento popstate (botão voltar/avançar)
  window.addEventListener('popstate', () => {
    console.log("🔄 [FORM MULTI] Popstate detectado (navegação voltar/avançar)");
    setTimeout(() => processAllForms(), 500);
    setTimeout(() => processAllForms(), 1000);
  });

  // ==========================================
  // 📱 LISTENER PARA RESIZE (Mobile/Desktop)
  // ==========================================
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      console.log("📱 [FORM MULTI] Resize detectado, reprocessando formulários");
      processAllForms();
    }, 250);
  });

  // ==========================================
  // 🚀 INICIALIZAÇÃO
  // ==========================================
  
  // Tenta processar imediatamente
  processAllForms();
  
  // Tenta novamente após delays
  setTimeout(() => processAllForms(), 500);
  setTimeout(() => processAllForms(), 1000);
  setTimeout(() => processAllForms(), 2000);
  setTimeout(() => processAllForms(), 3000);

  console.log("✅ [FORM MULTI] Sistema multi-formulários ativado!");
  console.log("📦 [FORM MULTI] Monitorando", CONTAINER_IDS.length, "container(s):");
  CONTAINER_IDS.forEach((id, index) => {
    console.log(`   ${index + 1}. ${id}`);
  });
  console.log("📍 [FORM MULTI] Página inicial:", window.location.pathname);

  // Expõe função global para debug/teste manual
  window.reprocessAllForms = () => {
    console.log("🔧 [FORM MULTI] Reprocessamento manual solicitado");
    processAllForms();
  };

  // Função para adicionar novo container ID dinamicamente
  window.addFormContainer = (newContainerId) => {
    if (!CONTAINER_IDS.includes(newContainerId)) {
      CONTAINER_IDS.push(newContainerId);
      console.log("➕ [FORM MULTI] Novo container adicionado:", newContainerId);
      processAllForms();
    } else {
      console.log("⚠️ [FORM MULTI] Container já existe na lista:", newContainerId);
    }
  };

})();
